import React from "react";

const Project = props => {
  return (
    <div className={`project-item ${props.largeItem}`}>
      <h3>
        <a href={props.url} target="_blank" rel="noopener noreferrer">
          {props.title}
        </a>
        {/* <br /> */}
      </h3>
      <p>
        <a href={props.sourceCode} target="_blank" rel="noopener noreferrer">
          <small>{props.sourceCodeTitle}</small>
        </a>
      </p>
    </div>
  );
};

export default Project;

/**
 * TODO: add prop types
 */
